exports = module.exports = require("../../../../../graylog2-server/graylog2-web-interface/node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".pipeline-stage{border:1px solid #666;border-radius:4px;display:inline-block;margin-right:15px;padding:20px;text-align:center;width:120px}.pipeline-stage.idle-stage{background-color:#e3e5e5;border-color:#d0d4d4}.pipeline-stage.used-stage{background-color:#fff}.pipeline-name{max-width:300px;overflow-x:hidden;text-overflow:ellipsis;white-space:nowrap;width:300px}.stream-list{max-width:150px;width:150px;word-wrap:break-word}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// /var/lib/jenkins/jobs/graylog-project-cli-release/workspace/.repos/graylog2-server/graylog2-web-interface/~/css-loader!./src/web/pipelines/ProcessingTimelineComponent.css
// module id = 493
// module chunks = 0